const columns_test = [
    {
        label: 'ID',
        field: 'id',
        type: 'number',
    },
    {
        label: 'Name',
        field: 'name',
        type: 'text',
    },
    // {
    //     label: 'Updated',
    //     field: 'time_updated',
    //     type: 'text',
    //     formatFn: (date) => {
    //         if(date){
    //         if(date.includes('T')){
    //             return date.split('T')[0]
    //         }
    //         }
    //         return date
    //     }
    // },
    // {
    //     label: 'Price',
    //     field: 'price',
    //     type: 'number',
    //     formatFn: (value) => {
    //         if(value){
    //         return numeral(value).format('$0,0,0,0,0.00')
    //         }
    //         return value
    //     }
    // }
];

export {columns_test};